import { render, staticRenderFns } from "./SkeletonReporte.vue?vue&type=template&id=4011c387&scoped=true&"
import script from "./SkeletonReporte.vue?vue&type=script&lang=js&"
export * from "./SkeletonReporte.vue?vue&type=script&lang=js&"
import style0 from "./SkeletonReporte.vue?vue&type=style&index=0&id=4011c387&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4011c387",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VSkeletonLoader } from 'vuetify/lib/components/VSkeletonLoader';
installComponents(component, {VSkeletonLoader})
